import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { Listado } from "./components/Listado";
import TabBar from "rc-tabs/lib/TabBar";
import { Link } from "react-router-dom";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import "./styles/Producciones.css";
import { ESTADOS_PRODUCCION } from "../../../../../../../utility/constants";

class Producciones extends Component {
    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);
        let tabFromUrl = params.get("tab");

        // significa que fue carga nueva, por lo tanto no se conserva el estado anterior de filtros y página
        if (!tabFromUrl) {
            tabFromUrl = "PROGRAMADAS";

            params.set("tab", tabFromUrl);

            this.props.history.replace({
                search: params.toString(),
            });

            sessionStorage.removeItem("producciones_programadas_state");
            sessionStorage.removeItem("producciones_en_proceso_state");
            sessionStorage.removeItem("producciones_finalizadas_state");
        }

        this.state = {
            tab: tabFromUrl,
        };
    }

    handleChangeTab = (tab) => {
        this.setState({ tab });

        const params = new URLSearchParams(this.props.location.search);
        params.set("tab", tab);

        this.props.history.replace({
            search: params.toString(),
        });
    };

    render() {
        const { user } = this.props;

        return (
            <div
                className="mb-4 col-12"
                style={{ maxWidth: "92vw", margin: "auto" }}
            >
                <Card
                    icon="produccion_activo"
                    titulo="PRODUCCIÓN"
                    subtitulo=""
                    noBorder
                >
                    <Tabs
                        activeKey={this.state.tab}
                        tabBarPosition="top"
                        onChange={this.handleChangeTab}
                        renderTabBar={() => <TabBar />}
                        renderTabContent={() => <TabContent />}
                    >
                        <TabPane tab="PROGRAMADAS" key="PROGRAMADAS">
                            <Listado
                                storageKey="producciones_programadas_state"
                                estado={ESTADOS_PRODUCCION.PENDIENTE}
                            />
                        </TabPane>
                        <TabPane tab="EN PROCESO" key="EN_PROCESO">
                            <Listado
                                storageKey="producciones_en_proceso_state"
                                estado={ESTADOS_PRODUCCION.EN_PROCESO}
                            />
                        </TabPane>
                        <TabPane tab="FINALIZADAS" key="FINALIZADAS">
                            <Listado
                                storageKey="producciones_finalizadas_state"
                                estado={ESTADOS_PRODUCCION.FINALIZADA}
                            />
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(Producciones);
